import React, { useEffect, useRef, useState } from 'react';

// Kutulu ÇOKLU seçim (2026-10-26, kullanıcı isteği "tüm özelliklerde checkbox ile seçim"): düğme + açılır
// checkbox listesi. Boş seçim = tümü. PuanSecici bunun sarmalayıcısıdır; müşteri panelinin bütün
// süzgeçleri bunu kullanır. `secenekler`: [{ value, label, grup? }] — `grup` değişince başlık basılır.
// `onDegis(dizi)` seçenek sırasıyla döner. `nitelik`: kök/kutu/Tümü için data-* adları (PuanSecici'nin
// eski öznitelikleri testlerde kilitli).
const varsayilanOzet = (secili, secenekler) => {
  if (secili.length === 0 || secili.length === secenekler.length) return 'tümü';
  if (secili.length > 2) return `${secili.length} seçili`;
  return secili.map((o) => o.label).join(', ');
};

export default function CokluSecici({
  deger, onDegis, secenekler, etiket, ariaLabel = etiket, title = `${etiket} — birden çok seçilebilir`,
  ozet = varsayilanOzet, dugmeSinifi = null, nitelik = { kok: 'data-coklu-secici', kutu: 'data-secenek', tumu: 'data-tumu' },
}) {
  const [acik, setAcik] = useState(false);
  const kutu = useRef(null);
  const secili = new Set(Array.isArray(deger) ? deger : []);
  const aktif = secili.size > 0;

  useEffect(() => {
    if (!acik) return undefined;
    const disari = (e) => { if (kutu.current && !kutu.current.contains(e.target)) setAcik(false); };
    const kacis = (e) => { if (e.key === 'Escape') setAcik(false); };
    document.addEventListener('mousedown', disari);
    document.addEventListener('keydown', kacis);
    return () => { document.removeEventListener('mousedown', disari); document.removeEventListener('keydown', kacis); };
  }, [acik]);

  const degistir = (v) => {
    const yeni = new Set(secili);
    if (yeni.has(v)) yeni.delete(v); else yeni.add(v);
    onDegis(secenekler.map((o) => o.value).filter((x) => yeni.has(x)));
  };

  const sinif = dugmeSinifi ? dugmeSinifi(aktif)
    : `px-2 py-1.5 rounded border text-xs ${aktif ? 'border-blue-400 bg-blue-50 text-blue-800 font-semibold' : 'border-gray-300 bg-white text-gray-700'}`;

  return (
    <div className="relative inline-block" ref={kutu} {...{ [nitelik.kok]: ariaLabel }}>
      <button type="button" aria-label={ariaLabel} aria-haspopup="true" aria-expanded={acik} title={title}
        onClick={() => setAcik((a) => !a)} className={`${sinif} max-w-[18rem] truncate`}>
        {etiket}: {ozet(secenekler.filter((o) => secili.has(o.value)), secenekler)} ▾
      </button>
      {acik && (
        <div role="group" aria-label={`${etiket} seçenekleri`}
          className="absolute z-30 mt-1 min-w-[11rem] max-w-[24rem] max-h-72 overflow-y-auto rounded border border-gray-200 bg-white p-1.5 shadow-lg">
          <label className="flex cursor-pointer items-center gap-2 rounded px-1.5 py-1 text-xs hover:bg-gray-50">
            <input type="checkbox" checked={!aktif} onChange={() => onDegis([])} {...{ [nitelik.tumu]: true }} />
            <span className="font-semibold">Tümü</span>
          </label>
          <div className="my-1 h-px bg-gray-100" />
          {secenekler.map((o, i) => (
            <React.Fragment key={o.value}>
              {o.grup && o.grup !== (secenekler[i - 1] || {}).grup && (
                <div className="px-1.5 pt-1.5 pb-0.5 text-[10px] font-bold uppercase tracking-wide text-gray-400">{o.grup}</div>
              )}
              <label className="flex cursor-pointer items-start gap-2 rounded px-1.5 py-1 text-xs hover:bg-gray-50">
                <input type="checkbox" className="mt-0.5" value={o.value} checked={secili.has(o.value)} onChange={() => degistir(o.value)}
                  {...{ [nitelik.kutu]: o.value }} />
                <span>{o.label}</span>
              </label>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}
